import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=bb6eb8f6&"
import script from "./FormSelect.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FormSelect.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports